<template>
  <ValidationObserver ref="newTalentPool">
    <Dialog :data="dialogSettings">
      <ValidationProvider v-slot="{ errors }" name="name" rules="required">
        <v-text-field
          class="mt-10"
          v-model="name"
          label="Name"
          :error-messages="showValidationErrors ? errors : ''"
        />
      </ValidationProvider>
      <template v-slot:dialog.actions>
        <PrimaryButton @click.native="close" text>Cancel</PrimaryButton>
        <PrimaryButton @click.native="onSubmit" :loading="isLoading">
          Create Talent Pool
        </PrimaryButton>
      </template>
    </Dialog>
  </ValidationObserver>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import Dialog from "@/components/common/Dialog";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { TALENT_POOLS_NAMESPACE } from "@/store/modules/talentPools";
import { ADD_NEW_TALENT_POOL } from "@/store/modules/talentPools/actions";
import { createNamespacedHelpers } from "vuex";

const { mapActions } = createNamespacedHelpers(TALENT_POOLS_NAMESPACE);

export default {
  name: "NewTalentPoolDialog",
  components: {
    Dialog,
    PrimaryButton,
    ValidationObserver,
    ValidationProvider
  },
  props: {
    additionalAction: Function
  },
  data() {
    return {
      name: "",
      showValidationErrors: false,
      isLoading: false,
      dialogSettings: {
        dialog: true,
        title: "New Talent Pool"
      }
    };
  },
  methods: {
    ...mapActions({
      addTalentPool: ADD_NEW_TALENT_POOL
    }),
    close() {
      this.$emit("close");
    },
    onSuccess() {
      this.$emit("onSuccess");
    },
    async onSubmit() {
      this.showValidationErrors = true;
      const isValid = await this.$refs.newTalentPool.validate();
      if (isValid) {
        this.isLoading = true;
        const { id } = await this.addTalentPool({ name: this.name });
        if (this.additionalAction) {
          await this.additionalAction(id);
        }
        this.onSuccess();
        this.isLoading = false;
      }
    }
  }
};
</script>

<style></style>
